import { AppsFilterAtom } from "pages/browse-apps/browse-apps.service";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useRecoilValue } from "recoil";
import { get_apps, get_appTags } from "services/appsServices";

export function useApps() {
	const { t } = useTranslation();
	const filters = useRecoilValue(AppsFilterAtom);

	const { isLoading, isError, isFetching, isSuccess, ...result } = useQuery(
		["apps", t, filters],
		async () => {
			const params = {
				moduleIds: filters.modules,
				subscriptionTypeId: filters.subscriptionType,
				priceFrom: filters.priceRange[0],
				priceTo: filters.priceRange[1],
				searchTerm: filters.search,
			};

			const { response } = await get_apps(params);
			if (response) return response;
		}
	);

	return {
		...result,
		appsList: result.data?.applications ?? [],
		addOnsList: result.data?.addOns ?? [],
		isLoading,
		isError,
		isFetching,
		isSuccess,
	};
}

export function useAppTags() {
    const {isLoading, isError, isFetching, isSuccess,...result} = useQuery('app-tags', async () => {
        const { response } = await get_appTags()
        if (response) return response
    })

    return { ...result, appTags: result.data?.items ?? [],isLoading, isError, isFetching, isSuccess }
}